/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Paper, Button, Modal } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';
import ReactPlayer from 'react-player';

import './scss/single-video.scss';
import Color from '@tool/color';
import moStore from '@store/index';
import moUser from '@store/user';
import moSkin from '@store/skin';
import moHome, { toggleOpen } from '@store/home';
import { CloseIcon } from '@styled/icon';

interface IProps {
  videoUrl: string,
  isOpen: boolean,
}
interface IState {}

const DButton = styled(Button)(() => ({}));

const DModal = styled(Modal)(() => ({
  zIndex: 5555555,
}));

const SingleVideo = (props: IProps, state: IState) => {
  const { videoUrl, isOpen } = props;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <DModal open={isOpen}>
      <section className="video-1155">
        <section className="video-1166">
          <ReactPlayer playing={true} controls={true}
            width={1000} height={500} url={videoUrl} />
          <p className="close-111" aria-hidden="true"
            onClick={() => toggleOpen(false)}>
            <CloseIcon width={30} height={30} color={Color.fff} />
          </p>
        </section>
      </section>
    </DModal>
  );
};

export default observer(SingleVideo);
